import React, { useMemo, useState } from 'react';

import {
  SidePage,
  Button,
  Stack,
  Grid,
  SearchInput,
  Divider,
  Tooltip,
} from '@gogame/components';
import { MetricsPicker } from '@gogame/components';

import ApplyFiltersButton from 'scenes/Trackers/HourlyTracker/components/Filters/ApplyFiltersButton';
import ActionsComponent from 'scenes/Trackers/Tracker/components/ColumnsPicker/Actions';
import { formatData } from 'scenes/Trackers/Tracker/components/ColumnsPicker/formatMetricsIntoGroups';

import { useLoadColumns } from '../data';

const EMPTY_ARR = [];

function getOptionMetricValue({ id }) {
  return id;
}
function getOptionLabel({ displayName }) {
  return displayName;
}
const HourlyTrackerColumnPicker = ({
  value = EMPTY_ARR,
  onSubmit,

  loading,
  fetching,
  onClose,
  open,
  onExited,
}) => {
  const [selected, setSelected] = useState(value);
  const [searchQuery, setSearchQuery] = useState('');
  const { data = {}, isLoading } = useLoadColumns();
  const { metrics = EMPTY_ARR } = data;

  const handleClearAll = () => {
    setSelected([]);
  };

  const handleSubmit = (apply) => () => {
    const allMetricsNames = metrics.map(({ id }) => id).filter((id) => id);
    const result = selected.filter((metric) =>
      allMetricsNames.includes(metric)
    );
    onSubmit({ order: result, apply });
  };

  const dirty = useMemo(() => {
    return selected.toString() !== value.toString();
  }, [selected]);

  return (
    <SidePage
      size={'lg'}
      onClose={onClose}
      onExited={onExited}
      loading={loading || isLoading}
      fetching={fetching}
      open={open}
    >
      <SidePage.Title title={'Customize Columns'} />
      <SidePage.NewBody disableGutters={true} dense={true} scroll={false}>
        <div style={{ padding: 16 }}>
          <SearchInput
            value={searchQuery}
            onChange={(_e, value) => {
              setSearchQuery(value);
            }}
            onClear={() => setSearchQuery('')}
          />
        </div>
        <Divider />
        <MetricsPicker
          grouped={true}
          metrics={metrics}
          getOptionMetricValue={getOptionMetricValue}
          getOptionLabel={getOptionLabel}
          searchQuery={searchQuery}
          onClearAll={handleClearAll}
          selected={selected}
          formatData={formatData}
          setSelected={setSelected}
          filterField={'displayName'}
          disabledSmartTooltip={true}
          groupAction={(option) => (
            <ActionsComponent
              disabledMetricManagement={true}
              disabledSmartTooltip={true}
              {...option}
            />
          )}
        />
      </SidePage.NewBody>
      <SidePage.Actions>
        <Grid container justifyContent={'space-between'}>
          <SidePage.CloseButton />
          <Stack spacing={1} direction={'row'}>
            <Tooltip title={'Save filters'} tooltipPlacement={'bottom'}>
              <div>
                <Button onClick={handleSubmit(false)} disabled={!dirty}>
                  Save
                </Button>
              </div>
            </Tooltip>
            <ApplyFiltersButton onClick={handleSubmit(true)} dirty={dirty} />
          </Stack>
        </Grid>
      </SidePage.Actions>
    </SidePage>
  );
};

export default HourlyTrackerColumnPicker;
